module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (Array.isArray(_vm.participants) && _vm.participants.length > 0) ? _c('div', _vm._l((_vm.participants), function(participant, key) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
    }, [_c('transition-group', {
      attrs: {
        "name": "list"
      }
    }, [(_vm.current == key) ? _c('participant-block', {
      key: key,
      attrs: {
        "participantId": participant
      },
      on: {
        "confirmed": _vm.confirm
      }
    }) : _vm._e()], 1)], 1)
  })) : _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-5x dark"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e15c7816"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cart/Participants/Participants.vue
// module id = 192
// module chunks = 0